import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";

// Assets
import EmptyState from "assets/empty-state-buyer-match.png";
import IEmptyArchived from "assets/empty-state-list-archived.png";

// Components
import ModalLoader from "components/organism/ModalLoader";
import Button from "components/v1/Button";
import ModalDetailFeed from "./modal-detail-feed";

const widthContainer = 1139;

const Size = {
  marketing: 214,
  listing: 169.5,
  coBroking: 169.5,
  tanggalKunjungan: 169.5,
  keterangan: 195,
  aksi: 75,
};

// Class
const headerRowClassName =
  "flex items-center px-4 py-2 gap-[24px] bg-[#FaFaFa] border-b-[1px] border-solid border-[#D8D8D9]";
const headerColClassName =
  "text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#808285]";

const bodyRowClassName =
  "flex items-center px-4 py-[10px] gap-[24px] border-b-[0.5px] border-solid border-[#D8D8D9]";
const bodyColClassName =
  "text-[13px] leading-[21px] tracking-[-0.4px] font-inter truncate";

const FeedTable = ({ data, isLoading, isSearch }) => {
  const [selectedFeedId, setSelectedFeedId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (feedId) => {
    setSelectedFeedId(feedId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedFeedId(null);
  };
  const { pathname } = useLocation();
  const isArchived = pathname.includes("list-archived");

  const _getSize = (size) => {
    return `${(size / widthContainer) * 100}%`;
  };

  const groupedData = useMemo(() => {
    if (!data || data.length === 0) return {};

    return data.reduce((acc, item) => {
      const date = item?.visit_date || "No Date";
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    }, {});
  }, [data]);

  const renderMessage = useMemo(() => {
    let msg = {
      title: "",
      subtitle: "",
    };

    // List buyer search
    if (isSearch) {
      msg.title = "Customer Tidak Ditemukan";
      msg.subtitle =
        "Periksa kembali ejaan nama atau buat profil customer baru jika belum terdaftar.";

      return msg;
    }

    // List buyer
    if (!isSearch && !isArchived) {
      msg.title = "Belum ada profil customer";
      msg.subtitle =
        "Tambahkan profil customer untuk mulai menyesuaikan listing sesuai preferensi mereka.";

      return msg;
    }

    // List buyer archived
    if (!isSearch && isArchived) {
      msg.title = "Tidak Ada Arsip";
      msg.subtitle =
        "Belum ada customer yang Anda arsipkan. Customer yang diarsipkan akan ditampilkan di sini.";

      return msg;
    }

    return msg;
  }, [isSearch, isArchived]);

  return (
    <>
      <div className="rounded-[4px] border-[0.5px] border-solid border-[#D8D8D9] min-w-[1149px]">
        {/* Header */}
        <div className={headerRowClassName}>
          <div style={{ width: _getSize(Size.marketing) }}>
            <span className={headerColClassName}>Marketing</span>
          </div>
          <div style={{ width: _getSize(Size.listing) }}>
            <span className={headerColClassName}>Listing</span>
          </div>
          <div style={{ width: _getSize(Size.coBroking) }}>
            <span className={headerColClassName}>Co-Broking</span>
          </div>
          <div style={{ width: _getSize(Size.tanggalKunjungan) }}>
            <span className={headerColClassName}>Tanggal Kunjungan</span>
          </div>
          <div style={{ width: _getSize(Size.keterangan) }}>
            <span className={headerColClassName}>Keterangan</span>
          </div>
          <div style={{ width: _getSize(Size.aksi) }}>
            <span className={headerColClassName}>Aksi</span>
          </div>
        </div>

        {/* Body */}
        {!!data?.length ? (
          Object.entries(groupedData).map(([date, items]) => (
            <div key={`date-group-${date}`}>
              <div className="px-4 py-2 bg-[#F5F5F5] border-b-[0.5px] border-solid border-[#D8D8D9]">
                <span className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter text-[#686A68]">
                  {date}
                </span>
              </div>
              {items.map((item, index) => (
                <div
                  key={`table-buyer-${date}-${index}`}
                  className={bodyRowClassName}
                >
                  <div
                    style={{ width: _getSize(Size.marketing) }}
                    className="flex items-center gap-6"
                  >
                    <img
                      src={item?.user?.image}
                      alt={item?.user?.full_name}
                      className="w-[40px] h-[40px] object-cover rounded-full"
                    />
                    <span className={bodyColClassName}>
                      {item?.user?.full_name}
                    </span>
                  </div>
                  <div
                    style={{ width: _getSize(Size.listing) }}
                    className="flex flex-col"
                  >
                    <span className={bodyColClassName}>
                      ID:#{item?.property?.id}
                    </span>
                    <span
                      className={
                        bodyColClassName +
                        " truncate !text-[11px] text-[#686A68]"
                      }
                    >
                      {item?.property?.title}
                    </span>
                  </div>
                  <div style={{ width: _getSize(Size.coBroking) }}>
                    <span className={bodyColClassName}>
                    </span>
                    {item?.is_cobroke ? (
                      <span className="inline-flex items-center justify-center w-fit h-4 px-1 bg-[#EBF0F7] rounded-[2px] text-[11px] font-inter-semibold text-[#3268AE] mt-1">
                        co-broking
                      </span>
                    ) : (
                      <span className="inline-flex items-center justify-center w-fit h-4 px-1 bg-[#F5F5F5] rounded-[2px] text-[11px] font-inter-semibold text-[#686A68] mt-1">
                        non co-broking
                      </span>
                    )}
                  </div>
                  <div style={{ width: _getSize(Size.tanggalKunjungan) }}>
                    <span className={`${bodyColClassName}`}>
                      {item?.visit_date}
                    </span>
                  </div>
                  <div style={{ width: _getSize(Size.keterangan) }}>
                    <p className={`${bodyColClassName} line-clamp-2`}>
                      {item?.information}
                    </p>
                  </div>
                  <div style={{ width: _getSize(Size.aksi) }}>
                    <Button
                      text="Lihat Detail"
                      type="secondary"
                      size="xs"
                      className="!py-0 h-[24px] !px-2 !font-inter !text-[11px]"
                      onClick={() => handleOpenModal(item?.id)}
                    />
                  </div>
                </div>
              ))}
            </div>
          ))
        ) : !data?.length && !isLoading ? (
          <div className="h-[494px] flex flex-col items-center justify-center gap-0.5 py-6">
            <img
              className="w-[48px] h-[48px] object-contain"
              src={isArchived ? IEmptyArchived : EmptyState}
              alt="empty-state"
            />
            <p className="text-[13px] leading-[21px] tracking-[-0.4px] font-inter-semibold text-[#252526]">
              {renderMessage.title}
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] font-inter text-[#808285]">
              {renderMessage.subtitle}
            </p>
          </div>
        ) : null}
      </div>

      <ModalLoader open={isLoading} />
      <ModalDetailFeed
        isOpen={isModalOpen}
        feedId={selectedFeedId}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default FeedTable;
